module.exports = __webpack_public_path__ + "img/illustrations@2x.03126cda.png";